import React from "react";
import styles from "./UnitToggle.module.scss";

const UnitToggle = ({ options, activeIndex, onChange, className }) => {
  return (
    <div className={`${styles.container} ${className || ""}`}>
      {options.map((option, index) => (
        <button
          key={option.value ?? index}
          type="button"
          className={`${styles.tab} ${index === activeIndex ? styles.active : ""}`}
          onClick={() => onChange(index)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default UnitToggle;
